import 'popper.js/dist/popper.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createRoot } from 'react-dom/client';
import App from './app';
import "../www/assets/css/overrides.css"

const root = createRoot(document.getElementById('root'));
root.render(<App />);
